module.exports = __webpack_public_path__ + "img/combo-generico.322844e3.png";